import _ from 'lodash'
import request, { serviceV2 } from '@/utils/request'

const prefix = '/django_rest/company/application'

export default {
  getOfferLetterApplicationBaseInfoList (params) {
    return serviceV2.post('/application/offer-letter/base-info/', params)
  },
  getResumeDownloadUrl (jobId, candidateId, params) {
    return serviceV2.get(`/application/job/${jobId}/candidate/${candidateId}/resume-download/`, { params })
  },
  getUploadTaskHistory (params) {
    return request.get('/django_rest/applicant/batch-upload/history/', { params })
  },
  getUploadToken () {
    return request.post('/django_rest/applicant/batch-upload/upload/')
  },
  parseBatchUploadResume (params) {
    return request.post('/django_rest/applicant/batch-upload/parse/', params)
  },
  getResumeParseResult (params) {
    return request.get('/django_rest/applicant/batch-upload/parse/', { params })
  },
  submitBatchOssParseResume (params) {
    return request.post('/django_rest/applicant/batch-upload/oss-parse/submit/', params)
  },
  getBatchOssParseResult (params) {
    return request.get('/django_rest/applicant/batch-upload/oss-parse/', { params })
  },
  importBatchUploadedCandidate (params) {
    return request.post('/django_rest/applicant/batch-upload/import/', params)
  },
  uploadTaskFile (fileInfo) {
    const formData = new FormData()
    let onUploadProgress = null
    _.forEach(fileInfo, (value, key) => {
      if (key === 'onUploadProgress') {
        onUploadProgress = value
      } else if (value !== null && value !== undefined) {
        formData.append(key, value)
      }
    })
    return request.put('/django_rest/applicant/batch-upload/upload/', formData, { onUploadProgress })
  },
  getLanguageList () {
    return request.get('/django_rest/language/language/')
  },
  getLanguageLevelList () {
    return request.get('/django_rest/language/level/')
  },
  getLanguageCertificationList () {
    return request.get('/django_rest/language/certification/')
  },
  getEducationLevelList () {
    return request.get('/django_rest/education/level/')
  },
  getAcademicRatingList () {
    return request.get('/django_rest/education/academic-rating/')
  },
  getMajorList (params) {
    return request.get('/django_rest/education/major/', { params })
  },
  getSchoolList (params) {
    return request.get('/django_rest/education/school/', { params })
  },
  getIndustryList () {
    return request.get('/django_rest/work-experience/industries/')
  },
  getChatToolList () {
    return request.get('/django_rest/chat-tools/')
  },
  getSocialNetworkList () {
    return request.get('/django_rest/social-network/')
  },
  getJobFamilyList () {
    return request.get('/django_rest/work-experience/job-family/')
  },
  parseCandidateResumeByHR (fileInfo) {
    const formData = new FormData()
    let onUploadProgress = null
    _.forEach(fileInfo, (value, key) => {
      if (key === 'onUploadProgress') {
        onUploadProgress = value
      } else if (value !== null && value !== undefined) {
        formData.append(key, value)
      }
    })
    return request.post('/django_rest/company/application/parse-resume-file/', formData, { onUploadProgress })
  },
  getSalaryList () {
    return request.get('/django_rest/salary/')
  },
  createApplicationWithResume (resumeInfo) {
    return request.post('/django_rest/company/application/', resumeInfo)
  },
  getApplicationResumeInfo (applicationId) {
    return request.get(`/django_rest/company/application/${applicationId}`)
  },
  updateApplicationResume (applicationId, resumeInfo) {
    return request.put(`/django_rest/company/application/${applicationId}`, resumeInfo)
  },
  hasIdNumberField () {
    return request.get('/django_rest/company/application/has-id-number/')
  },
  uploadApplicationCandidatePhoto (candidateId, jobId, photo) {
    const formData = new FormData()
    formData.append('photo', photo)
    if (jobId !== null && jobId !== undefined) {
      formData.append('job_id', jobId)
    }
    return request.post(`/django_rest/company/application/${candidateId}/photo/`, formData)
  },
  handleOpenQuestionUploadedVideo (info) {
    return request.post('/django_rest/company/application/question-uploaded-video/', info)
  },
  getOpenQuestionUploadedVideoDuration (params) {
    return request.get('/django_rest/company/application/question-uploaded-video/', { params })
  },
  getRecruiterQuestionnaire (jobId, params) {
    return request.get(`/django_rest/company/job/${jobId}/open-question/recruiter/`, { params })
  },
  getApplicationQuestionnaire (jobId, params) {
    return request.get(`/django_rest/company/job/${jobId}/open-question/standard/`, { params })
  },
  getPrescreenQuestionnaire (jobId, params) {
    return request.get(`/django_rest/company/job/${jobId}/open-question/prescreen/`, { params })
  },
  getHeadhunterUploadedCandidateCount (params) {
    return request.get('/django_rest/headhunter/candidate/upload/count/', { params })
  },
  getDuplicateCandidateList (params) {
    return request.get('/django_rest/company/application/duplicate-candidate/', { params })
  },
  getHrQuestion (jobId) {
    return request.get(`/django_rest/company/job/${jobId}/open-question/hr/`)
  },
  checkEmailOrPhoneApplication (params) {
    return request.get('/django_rest/company/application/apply-check/', { params })
  },
  getCandidateStatusGroupList (params) {
    return request.get(`${prefix}/status/`, { params })
  },
  changeCandidateStatus (statusInfo) {
    return request.put(`${prefix}/status/`, statusInfo)
  },
  getGroupList (params) {
    return request.get('/django_rest/group/', { params })
  },
  saveCandidateGroup (groupInfo) {
    return request.post(`${prefix}/group/`, groupInfo)
  },
  moveCandidateGroup (groupInfo) {
    return request.put(`${prefix}/group/`, groupInfo)
  },
  getCompanyApplicationList (params) {
    return request.get(`${prefix}/`, { params })
  },
  getJobApplicationList (jobId, params) {
    return request.get(`/django_rest/company/job/${jobId}/application/`, { params })
  },
  createHrInterview (interviewInfo) {
    return serviceV2.post('/interview/hr-start/', interviewInfo)
  },
  createHrRating (ratingInfo) {
    return request.post('/django_rest/hm/rating/hr-start/', ratingInfo)
  },
  getHrRatingQuestionnaireResults (params) {
    return serviceV2.get(`/hr/application/job/${params.job_id}/candidate/${params.candidate_id}/rating-questionnaire-results/`)
  },
  copyCandidate (params) {
    return request.post('/django_rest/copy-candidate/', params)
  },
  inviteCandidateApplyJob (invitation) {
    return request.post(`${prefix}/invite/apply-job/`, invitation)
  },
  getCandidateCanInviteJobList (params) {
    return request.get(`${prefix}/invite/apply-job/`, { params })
  },
  addComment (comment) {
    return request.post(`${prefix}/comment/`, comment)
  },
  contactCandidate (contactInfo) {
    return request.post('/django_rest/company/candidate/contact/', contactInfo)
  },
  sendInviteNotification (invitation) {
    return request.post(`${prefix}/invite/send-notification/`, invitation)
  },
  inviteOpenQuestion (invitation) {
    return request.post(`${prefix}/invite/open-question/`, invitation)
  },
  exportCandidateProfilePDF (applicationInfo) {
    return request.post(`${prefix}/export/profile/`, applicationInfo)
  },
  getExportCandidateProfilePDFTaskStatus (params) {
    return request.get(`${prefix}/export/profile/`, { params })
  },
  exportConsentInfoPDF (params) {
    return request.get('/pdf/pdf/candidate-agree-policy-records/', { params })
  },
  getExportConsentInfoPDFTaskStatus (params) {
    return request.get('/pdf/download_consent_pdf/', { params })
  },
  exportCandidateProfileWord (applicationInfo) {
    return request.post('/word/word/', applicationInfo)
  },
  createProfileShareLinkCode (shareInfo) {
    return request.post(`${prefix}/share-link/`, shareInfo)
  },
  viewApplication (jobId, candidateId) {
    return request.post(`${prefix}/viewed/`, null, { params: { job_id: jobId, candidate_id: candidateId, source: 'PC' } })
  },
  changeAgencyUploadedCandidateStatus (info) {
    return request.post('/django_rest/company/candidate/agency-uploaded/', info)
  },
  getApplicationIdList (params) {
    return request.get(`${prefix}/all-application-ids/`, { params })
  },
  exportCandidateConsentPDF (params) {
    return request.post(`${prefix}/export/candidate/consent/`, params)
  },
  getExportCandidateConsentPDFaskStatus (params) {
    return request.get(`${prefix}/export/candidate/consent/`, { params })
  },
  exportApplicationCandidateWord (params) {
    return request.post(`${prefix}/export/candidate/word/`, params)
  },
  getExportCandidateWordTaskStatus (params) {
    return request.get(`${prefix}/export/candidate/word/`, { params })
  },
  sendInviteAnswerOriginCompanyQuestion (params) {
    return request.post(`${prefix}/invite/origin-company-question/`, params)
  },
  getAssessmentFitCount (params) {
    return request.get('/django_rest/assessment-fit-count/', { params })
  },
  getProblemSolvingFitCount (params) {
    return request.get('/django_rest/resume-fit-count/', { params })
  },
  getCandidateConsentInfo (params) {
    return request.get(`/django_rest/company/candidate/${params.candidate_id}/consent/`, { params })
  },
  createGroup (params) {
    return request.put('/django_rest/candidates-group/', params)
  },
  updateGroup (params) {
    return request.post('/django_rest/group/', params)
  },
  deleteGroup (params) {
    return request.delete('/django_rest/group/', { params })
  },
  removeCandidateFromGroup (params) {
    return request.post('/django_rest/candidates-group/', params)
  },
  getExportJobApplicationExcelFieldInfo () {
    return request.get('/django_rest/company/job/application/export-excel/')
  },
  createExportJobApplicationExcelInfoTask (params) {
    return request.post('/django_rest/company/job/application/export-excel/', params)
  },
  exportCandidateProfilePdf (params) {
    return request.post('/django_rest/company/job/application/export/profile/', params)
  },
  getExportCandidateProfilePdfTaskStatus (params) {
    return request.get('/django_rest/company/job/application/export/profile/', { params })
  },
  exportConsentPDF (params) {
    return request.post('/django_rest/company/job/application/export/consent/', params)
  },
  getExportConsentPDFaskStatus (params) {
    return request.get('/django_rest/company/job/application/export/consent/', { params })
  },
  // 导出原始简历
  exportOriginalResume (params) {
    return request.post('/django_rest/company/candidate/export/original-resume/', params)
  },
  getExportOriginalResumeTaskStatus (params) {
    return request.get('/django_rest/company/candidate/export/original-resume/', { params })
  },
  getApplicationCandidateBaseInfo (params) {
    return request.get(`${prefix}/job/${params.job_id}/candidate/${params.candidate_id}/base-info/`)
  },
  getApplicationCandidateResumeInfo (params) {
    return request.get(`${prefix}/job/${params.job_id}/candidate/${params.candidate_id}/resume/`)
  },
  getApplicationOpenQuestionInfo (params) {
    return request.get(`${prefix}/job/${params.job_id}/candidate/${params.candidate_id}/open-question/`, { params })
  },
  updateApplicationOpenQuestionInfo (jobId, candidateId, data) {
    return request.put(`${prefix}/job/${jobId}/candidate/${candidateId}/open-question/`, data)
  },
  getApplicationCandidateHmRateInfo (params) {
    return request.get(`${prefix}/job/${params.job_id}/candidate/${params.candidate_id}/hm-rate/`)
  },
  getApplicationCandidateInterviewInfo (params) {
    return request.get(`${prefix}/job/${params.job_id}/candidate/${params.candidate_id}/interview/`)
  },
  getApplicationCandidateProfileTabInfo (params) {
    return serviceV2.get(`/application/job/${params.job_id}/candidate/${params.candidate_id}/profile/tab/`)
  },
  getApplicationCandidateActivityInfo (params) {
    return request.get(`${prefix}/job/${params.job_id}/candidate/${params.candidate_id}/activity/`)
  },
  getApplicationCandidateTagInfo (params) {
    return request.get(`${prefix}/job/${params.job_id}/candidate/${params.candidate_id}/tag/`, { params })
  },
  getApplicationCandidateSurveyInfo (params) {
    return request.get(`${prefix}/job/${params.job_id}/candidate/${params.candidate_id}/survey/`, { params })
  },
  getApplicationDuplicateCandidateInfo (params) {
    return request.get(`${prefix}/job/${params.job_id}/candidate/${params.candidate_id}/duplicate-candidate/`, { params })
  },
  createExportUniversalApplicationExcelInfoTask (params) {
    return request.post('/django_rest/company/application/export-excel/', params)
  },
  getJobApplyRequiredInfo (jobId) {
    return request.get(`/django_rest/job/apply/required/${jobId}/`)
  },
  inviteCandidateUploadResume (params) {
    return request.post(`${prefix}/invite/candidate-upload-resume/`, params)
  },
  inviteCandidateAiInterview (params) {
    return request.post(`${prefix}/invite/candidate-ai-interview/`, params)
  },
  getApplicationAISummary (params) {
    return request.get(`${prefix}/ai/summary/`, { params })
  },
  getApplicationAIMatchInfo (params) {
    return request.get(`${prefix}/ai/match-info/`, { params })
  },
  sendInviteCandidateOfferLetter (params) {
    return request.post(`${prefix}/invite/offer-letter/`, params)
  },
  resendInviteCandidateOfferLetter (params) {
    return request.put(`${prefix}/invite/offer-letter/`, params)
  },
  sendOfferLetterNotice (params) {
    return request.post(`${prefix}/offer-letter/send-notice/`, params)
  },
  getApplicationCandidateOfferLetterInfo (params) {
    return request.get(`${prefix}/job/${params.job_id}/candidate/${params.candidate_id}/offer-letter/`)
  },
  createExportCandidateOfferLetterInfoTask (params) {
    return request.post('/django_rest/company/job/application/export/offer-letter/', params)
  },
  getExportCandidateOfferLetterTaskStatus (params) {
    return request.get('/django_rest/company/job/application/export/offer-letter/', { params })
  },
  createParseResumeInfoByHRTask (data) {
    return request.post(`${prefix}/parse-resume-file/task/submit/`, data)
  },
  getParseResumeInfoByHRTaskStatus (params) {
    return request.get(`${prefix}/parse-resume-file/task/`, { params })
  }
}
